import _useRequest from "@byted/hooks/es/useRequest";
import _Message from "@arco-design/web-react/es/Message";
import _Modal from "@arco-design/web-react/es/Modal";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { SaveToken } from '@src/utils/api/theme';
import { diffDate } from '@src/utils/format';
import { IconHistory, IconLoading } from '@arco-design/web-react/icon';
import { useSelector, useDispatch } from 'react-redux';
import EditHistory from './editHistory';
import useLocale from '@src/hooks/useLocale';
import locale from '../locale';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
var AutoSaveToken = function AutoSaveToken(props) {
  var _a = useLocale(locale),
    t = _a.t,
    lang = _a.lang;
  var dispatch = useDispatch();
  var themeInfo = props.themeInfo,
    readonly = props.readonly;
  var editTokens = useSelector(function (state) {
    return state.token.editTokens;
  });
  var _b = __read(useState(false), 2),
    isEditing = _b[0],
    setIsEditing = _b[1];
  var themeId = themeInfo.themeId;
  var isPreview = usePreviewVersion().isPreview;
  var saveTokens = function saveTokens() {
    return __awaiter(void 0, void 0, void 0, function () {
      var tokens, list, payload_1, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            tokens = Object.keys(editTokens).map(function (key) {
              return __assign(__assign({
                themeId: themeId
              }, editTokens[key]), {
                key: key
              });
            });
            if (!tokens.length) return [3, 2];
            return [4, SaveToken({
              tokens: tokens
            })];
          case 1:
            list = _a.sent();
            if (!isEditing) {
              setIsEditing(true);
            }
            payload_1 = {};
            list.forEach(function (item) {
              payload_1[item.key] = {
                key: item.key,
                value: item.value,
                component: item.component,
                version: item.version
              };
            });
            dispatch({
              type: 'saveToken',
              payload: payload_1
            });
            _a.label = 2;
          case 2:
            return [3, 4];
          case 3:
            e_1 = _a.sent();
            if (e_1.response.status === 400) {
              cancel();
              _Modal.error({
                title: t['autoSave.modal.title'],
                content: t['autoSave.modal.content'],
                closable: false,
                maskClosable: false,
                onOk: function onOk() {
                  location.reload();
                }
              });
            } else {
              _Message.error(t['autoSave.modal.error'] + e_1.response.message);
            }
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  };
  var _c = _useRequest(saveTokens, {
      pollingInterval: 3000,
      auto: themeInfo.isMine && !readonly && !isPreview
    }),
    loading = _c.loading,
    cancel = _c.cancel;
  if (readonly) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", null, isEditing ? diffDate(themeInfo.updatedAt, lang) + '，' : loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconLoading, null), t['autoSave.loading'], "\uFF0C") : /*#__PURE__*/React.createElement(React.Fragment, null, isPreview ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconHistory, null), " ", t['autoSave.autosaved'], "\uFF0C")), themeInfo.isMine && /*#__PURE__*/React.createElement(EditHistory, {
    themeId: themeId
  }));
};
export default AutoSaveToken;